import React, { Component } from "react";
import withGameGridConfiguration from "../gameGrid/configuration/withGameGridConfiguration";


import * as PIXI from "pixi.js";
import { TIMER } from "../../core/utills";
import Symbol from "../../core/components/symbol/symbol";
import { withPixiApp } from "@inlet/react-pixi";
import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import UIManager from "../../core/components/ui/UiBuilder";
import { isMobile } from "react-device-detect";
import { PathTween } from "../../core/components/effect/pathtween";
import { Tween } from "../../core/components/effect/tween";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as gridActions } from "../../core/reducers/gridStateReducer";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import * as _ from "lodash";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as gaintWildActions } from "../../gamereducer/giantWildReducer";
import { actions as randomWildActions } from "../../gamereducer/gameRandomWildReducer";
import { GlitchFilter } from '@pixi/filter-glitch';
import { actions as winDropReducer } from "../../gamereducer/winDropReducer";
import { actions as skullActions } from "../../gamereducer/skullReducer";
import { configGame } from "../../data/config"
import easing from "../../core/components/effect/easing";
// import { actions as overlayActions } from "../../reducers/overlayreducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as gameRandomWildActions } from '../../gamereducer/gameRandomWildReducer';


window.PIXI = PIXI;


interface IStateToProps {
    //updatedSymbol: any
    blastPosition: any
    reel_data: any
    winningList: any
    isSpinning: boolean
    spinStart: boolean
    blastStart: boolean
    spinStop: boolean
    forceSpinStop: boolean
    spinResponseReceived: boolean
    layoutMode: string
    startDropCompleteCount: number,
    currentCascadeCount: number,
    totalCascadeCount: number,
    countStopReels: number,
    giantWildPositions: any,
    randomWildsPositions: any,
    allSpinComplete: any,
    immediateResponseReceived: boolean,
    InTurboMode: boolean,
    allSoundSFXStop: boolean,
    soundIsPlaying: boolean,
    showBannerForReconstruction: any,
}

interface IDispatchToProps {


}
interface IStore {
    [x: string]: any;
}

interface IProps extends IStateToProps {
    [x: string]: any;


}

interface IState {

}

class GameGrid extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected subGameGridContainer: any;
    protected eventEmitter: any;
    protected GRID_STOPS: Array<Array<number>>;
    protected newPositions: any;
    protected tweening: any;
    protected serverResponseReceived: Boolean;
    protected updateSymbol: Boolean;
    protected reelRunning: Boolean;
    protected blurReel: Boolean;
    protected spinMidCalled: Boolean;
    protected minimummSpinTimeComplete: Boolean;

    protected SPIN_MOVE_VALUE: number;
    protected totalCascadeCount: number;
    private gamePause: boolean;
    private tickupRequest: any;


    private gridPositions: any;
    private createPosition: any;
    private endPosition: any;
    private leftTilt: any
    private T50: number = 50;
    private T1000: number = 1000;
    private toConvertInSec: number = 1000;
    private regulationBetLimit: number = 1;
    responseReceivedAfterBlast: boolean;
    private stopButtonClicked: boolean;
    private dropComplete: boolean;




    constructor(props: IProps) {
        super(props);

        this.app = props.app;
        this.GRID_STOPS = [];
        this.newPositions = [];
        this.tweening = [];
        this.gamePause = false;

        this.responseReceivedAfterBlast = false;
        this.minimummSpinTimeComplete = false;
        this.spinMidCalled = false;
        this.serverResponseReceived = false;
        this.updateSymbol = false;
        this.reelRunning = false;
        this.blurReel = false;
        this.stopButtonClicked = false;
        this.SPIN_MOVE_VALUE = 0;
        this.regulationBetLimit = 1;
        this.totalCascadeCount = this.props.totalCascadeCount;
        this.dropComplete = false;
        this.subGameGridContainer = React.createRef();
        this.init();

    }

    init() {
        this.bindEvent();
        this.gridPositions = [{ x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }];
        this.createPosition = { x: 0, y: 0 };
        this.endPosition = { x: 0, y: 0 };
        this.props.setSpinType();
        if ((window as any).GAME_INFO.betLimit == 0) {
            this.regulationBetLimit = 1;
        } else {
            this.regulationBetLimit = (window as any).GAME_INFO.betLimit / 1000;
        }
        this.onInitializeReelStop();
    }

    destroy() {
    }

    bindEvent() {

    }

    onGameResume(data: any) {
        this.gamePause = false;

    }

    onGamePause(data: any) {
        this.gamePause = true;

    }

    onInitializeReelStop() {
        this.GRID_STOPS = this.props.reel_data.stopReels;
    }
    setDropSymbol() {

        if (!this.serverResponseReceived || !this.dropComplete) {
            return
        }
        this.dropComplete = false;
        this.serverResponseReceived = false;
        for (let i = 0; i < this.props.data.GRID_COLUMN; i++) {
            let gridSymbols = this.props.gridList[i].symbols,
                count = 0;
            this.newPositions = [];
            gridSymbols.forEach((symbol: any, index: number) => {
                count++;
                symbol.COMPONENT.updatedTexture = true;
                this.props.onUpdateSymbolOnReel(symbol.COMPONENT, this.GRID_STOPS[i][symbol.COMPONENT.gridPosition], false);
                symbol.COMPONENT.visible = true;
                symbol.COMPONENT.y = this.createPosition.y * count;
                if (gridSymbols.length - 1 === index) {
                    //
                    let timer = TIMER.TimerManager.createTimer(500 * this.regulationBetLimit);
                    timer.on('end', (e: any) => {
                        if (!this.stopButtonClicked) {
                            this.props.setStartDropComplete();
                        }
                    });
                    timer.start();
                }

            });
        }
    }
    onServerReelStop(data?: any) {
/*         this.props.setStopActive(true);
 */        if (this.props.GridIndex + 1 === this.props.data.GRID_COLUMN) {
            this.serverResponseReceived = true;

            this.setDropSymbol();
        }
    }


    componentDidMount() {

        let gridCoulmn = UIManager.getRef("gridGameCoulmn" + this.props.GridIndex);

        this.gridPositions = _.cloneDeep(this.props.data.gridPositions);
        this.gridPositions.forEach((pos: any) => {
            pos.x = pos.x + gridCoulmn.x;
            pos.y = pos.y + gridCoulmn.y;
        });

        this.createPosition.x = _.cloneDeep(this.props.data.createPosition).x + gridCoulmn.x;
        this.createPosition.y = _.cloneDeep(this.props.data.createPosition).y + gridCoulmn.y;

        this.endPosition.x = _.cloneDeep(this.props.data.endPosition).x
        this.endPosition.y = _.cloneDeep(this.props.data.endPosition).y;

        this.endPosition.x += gridCoulmn.x;
        this.endPosition.y += gridCoulmn.y;

        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
        gridSymbols.forEach((symbol: any, index: number) => {

            symbol.COMPONENT.gridPosition = index;
            symbol.COMPONENT.rowId = symbol.rowId;
            symbol.COMPONENT.reelId = symbol.reelId;
        });


    }



    layoutChange(currentLayout: string) {

    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.reel_data != this.props.reel_data) {
            if (nextProps.reel_data) {

                this.GRID_STOPS = nextProps.reel_data.stopReels

            }
        }
        if (nextProps.totalCascadeCount != this.props.totalCascadeCount) {
            if (nextProps.totalCascadeCount) {
                this.totalCascadeCount = nextProps.totalCascadeCount
            }
        }

        if (nextProps.isSpinning != this.props.isSpinning || nextProps.blastStart != this.props.blastStart || nextProps.spinStart != this.props.spinStart || nextProps.spinStop != this.props.spinStop
            || nextProps.forceSpinStop != this.props.forceSpinStop || nextProps.spinResponseReceived != this.props.spinResponseReceived
            || nextProps.layoutMode != this.props.layoutMode
            || nextProps.startDropCompleteCount != this.props.startDropCompleteCount
            || nextProps.countStopReels != this.props.countStopReels
            || nextProps.allSpinComplete != this.props.allSpinComplete
            || nextProps.immediateResponseReceived != this.props.immediateResponseReceived
            || nextProps.showBannerForReconstruction != this.props.showBannerForReconstruction
        ) {

            if (nextProps.allSpinComplete && nextProps.allSpinComplete != this.props.allSpinComplete) {
                if (nextProps.giantWildPositions.length) {
                    nextProps.startGiantWild();
                }
                if (nextProps.randomWildsPositions.length) {
                    nextProps.startRandomWild();
                }
            }

            if (nextProps.immediateResponseReceived && nextProps.immediateResponseReceived != this.props.immediateResponseReceived) {
                //this.startDropAfterBlast(nextProps.immediateResponseReceived);
                // this.responseReceivedAfterBlast = true;

                let timer = TIMER.TimerManager.createTimer(10 * nextProps.GridIndex);
                timer.on('end', (e: any) => {
                    e.remove();
                    this.continueFlow(nextProps);

                });
                timer.start();
                return false
            }

            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode)
                return false;
            }


            if (!nextProps.showBannerForReconstruction && nextProps.showBannerForReconstruction != this.props.showBannerForReconstruction) {
                this.startBlast();

            }
            if (nextProps.spinStart && nextProps.spinStart != this.props.spinStart) {
                this.props.featureActive(false);
                let tiltDirection = (Math.floor(Math.random() * 30)) % 2
                tiltDirection ? (this.leftTilt = true) : (this.leftTilt = false)
                this.props.setCurrentCascadeCount(0);
                this.props.flowManagerCalled(false);
                this.stopButtonClicked = false;
                this.onReelSpinStart();

                this.props.setSkullDuringCascade(false);

                // this.props.setStopActive(true);
            }
            if (nextProps.startDropCompleteCount === nextProps.data.GRID_COLUMN && nextProps.startDropCompleteCount != this.props.startDropCompleteCount) {

                this.createNewSymbols()
            }
            if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart) {
                nextProps.setSpinComplete(false);
                /*  this.props.setStopActive(false); */
                this.props.setSkullDuringCascade(false);

                if (nextProps.blastPosition == 0) {
                    this.onResetGrid(nextProps);
                    /*     this.props.setStopActive(false); */
                    this.props.flowManagerCalled(true);
                }
                else {

                    let gridSymbols = this.props.gridList[this.props.GridIndex];

                    let symbolslist = gridSymbols.symbols;
                    for (let i = 0; i < symbolslist.length; i++) {
                        let symbol = symbolslist[i];

                        symbol.COMPONENT.giantHide = false;
                    }

                    for (let i = 0; i < symbolslist.length; i++) {
                        let symbol = symbolslist[i];

                        // this.blastSymbol(symbol);

                        symbol.COMPONENT.gridPosition = i;
                        symbol.COMPONENT.rowId = symbol.rowId;
                        symbol.COMPONENT.reelId = symbol.reelId;


                        nextProps.blastPosition.forEach((data: any, index: number) => {

                            if (data.reelId === symbol.reelId && data.rowId === symbol.COMPONENT.gridPosition) {


                                symbol.COMPONENT.blasted = true;


                            }

                        })
                        let tempGiantArr = nextProps.giantWildPositions
                        tempGiantArr.forEach((position: any, index: number) => {
                            if (nextProps.GridIndex === position.reel) {
                                if (tempGiantArr.length === 4 && index === 1) {
                                    if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                        symbol.COMPONENT.giantHide = false;
                                    }
                                } else if (tempGiantArr.length === 9 && index === 2) {
                                    if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                        //symbol.COMPONENT.giantHide = true;
                                        symbol.COMPONENT.giantHide = false;
                                    }
                                } else {

                                    if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                        symbol.COMPONENT.giantHide = true;
                                    }
                                }
                            }

                        });
                        if (nextProps.giantWildPositions.length) {
                            if (nextProps.soundIsPlaying && !nextProps.allSoundSFXStop) {
                                nextProps.playSound([{ name: "popOutSound", loop: false }]);
                            }
                        }

                    }

                    this.responseReceivedAfterBlast = false;
                    !nextProps.showBannerForReconstruction && this.startBlast();

                }
            }

            if (nextProps.countStopReels === nextProps.data.GRID_COLUMN) {
                // if (nextProps.winningList.length == 0) {
                //     this.props.stopWinPresentation();
                // }
                if (!nextProps.blastStart) {

                    nextProps.setSpinComplete(true);

                    if (nextProps.winningList.length == 0) {

                        cancelAnimationFrame(this.tickupRequest);
                        this.onResetGrid(nextProps);
                        /*    this.props.setStopActive(false); */
                        this.props.flowManagerCalled(true);
                    } else {
                        this.props.displayWinBox(true)
                    }

                }


            }
            if (nextProps.spinResponseReceived && nextProps.spinResponseReceived != this.props.spinResponseReceived) {
                let timer = TIMER.TimerManager.createTimer(50);
                timer.on('end', (e: any) => {
                    e.remove();
                    this.onServerReelStop();

                });
                timer.start();

            }
            if (nextProps.forceSpinStop && nextProps.forceSpinStop != this.props.forceSpinStop) {


                // this.tweening = [];
                const remove: any = [];
                for (let i = 0; i < this.tweening.length; i++) {
                    const t = this.tweening[i];
                    t.duration = 0.7;
                    //t.onUpdate(t);
                    remove.push(t);
                }
                this.stopButtonClicked = true;
                for (let i = 0; i < remove.length; i++) {
                    this.tweening.splice(this.tweening.indexOf(remove[i]), 1);
                }
                // let gridSymbols = nextProps.gridList[nextProps.GridIndex].symbols;
                // gridSymbols.forEach((symbol: any, index: number) => {
                //     symbol.COMPONENT.y = this.createPosition.y * -index;
                // });
                // let timer = TIMER.TimerManager.createTimer(500);
                // timer.on('end', (e: any) => {
                //     e.remove();

                //     let gridSymbols = nextProps.gridList[nextProps.GridIndex].symbols;
                //     gridSymbols.forEach((symbol: any, index: number) => {
                //         symbol.COMPONENT.y = this.createPosition.y * -index;
                //     });


                // });
                // timer.start();

                let timer = TIMER.TimerManager.createTimer(700 + 10 * nextProps.GridIndex);
                timer.on('end', (e: any) => {
                    e.remove();

                    this.props.setStartDropComplete();

                });
                timer.start();


            }
            return false;
        }


        return false;
    }

    getSubReelContainer() {
        return this.subGameGridContainer;
    }
    startBlastAfterReconstruction(nextProps: any) {
        // if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart && !nextProps.showBannerForReconstruction) {
        nextProps.setSpinComplete(false);
        /*    this.props.setStopActive(false); */
        this.props.setSkullDuringCascade(false);

        if (nextProps.blastPosition == 0) {
            this.onResetGrid(nextProps);
            /*  this.props.setStopActive(false); */
            this.props.flowManagerCalled(true);
        } else {
            let gridSymbols = this.props.gridList[this.props.GridIndex];

            let symbolslist = gridSymbols.symbols;
            for (let i = 0; i < symbolslist.length; i++) {
                let symbol = symbolslist[i];

                symbol.COMPONENT.giantHide = false;
            }

            for (let i = 0; i < symbolslist.length; i++) {
                let symbol = symbolslist[i];

                // this.blastSymbol(symbol);

                symbol.COMPONENT.gridPosition = i;
                symbol.COMPONENT.rowId = symbol.rowId;
                symbol.COMPONENT.reelId = symbol.reelId;


                nextProps.blastPosition.forEach((data: any, index: number) => {

                    if (data.reelId === symbol.reelId && data.rowId === symbol.COMPONENT.gridPosition) {


                        symbol.COMPONENT.blasted = true;


                    }

                })
                let tempGiantArr = nextProps.giantWildPositions
                tempGiantArr.forEach((position: any, index: number) => {
                    if (nextProps.GridIndex === position.reel) {
                        if (tempGiantArr.length === 4 && index === 1) {
                            if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                symbol.COMPONENT.giantHide = false;
                            }
                        } else if (tempGiantArr.length === 9 && index === 2) {
                            if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                //symbol.COMPONENT.giantHide = true;
                                symbol.COMPONENT.giantHide = false;
                            }
                        } else {

                            if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {

                                symbol.COMPONENT.giantHide = true;
                            }
                        }
                    }

                });
                if (nextProps.giantWildPositions.length) {
                    if (nextProps.soundIsPlaying && !nextProps.allSoundSFXStop) {
                        nextProps.playSound([{ name: "popOutSound", loop: false }]);
                    }
                }

            }

            this.responseReceivedAfterBlast = false;
            this.startBlast();
        }



        // }
    }

    onResetGrid(PROPS: any) {
        PROPS.setWinSymbolCoOrdinate([]);

        let gridSymbols = PROPS.gridList[this.props.GridIndex].symbols;
        // gridSymbols.sort(this.compare_prop_y);


        for (let j = PROPS.data.GRID_ROWS - 1; j >= 0; j--) {

            gridSymbols[j].COMPONENT.gridPosition = j;
            gridSymbols[j].COMPONENT.rowId = j;

            gridSymbols[j].COMPONENT.blasted = false;
            gridSymbols[j].COMPONENT.giantHide = false;
            gridSymbols[j].COMPONENT.shiftCount = 0;
            gridSymbols[j].shifted = false

        }

        // gridSymbols.sort(this.compare_prop_y);
        // gridSymbols.forEach((symbol: any, index: number) => {
        //     symbol.COMPONENT.rowId = index;
        // })

    }



    reArrangeGridBeforeNextCascade() {

        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;

        for (let j = this.props.data.GRID_ROWS - 1; j >= 0; j--) {
            let shiftCount = gridSymbols[j].COMPONENT.shiftCount;
            if (gridSymbols[j].COMPONENT.blasted) {

                shiftCount = 0;
            }
        }


        gridSymbols.sort(this.compare_prop_y);

        gridSymbols.forEach((data: any, index: number) => {

            data.rowId = index;
            data.gridPosition = index;

            data.COMPONENT.rowId = index;
            data.COMPONENT.gridPosition = index;
            data.COMPONENT.y = this.gridPositions[this.gridPositions.length - 1 - index].y

        })
    }

    onReelSpinStart() {

        if (this.reelRunning) return;
        this.serverResponseReceived = false;
        let timer = TIMER.TimerManager.createTimer(1 + this.props.data.staggerColumnDelay * this.props.GridIndex);

        timer.on('end', (e: any) => {
            e.remove();
            this.startDrop(() => {
            }, () => {
            });

        });
        timer.start();

    }

    compare_prop_y(a: any, b: any) {

        // a should come before b in the sorted order
        if (a.COMPONENT.y < b.COMPONENT.y) {
            return -1;
            // a should come after b in the sorted order
        } else if (a.COMPONENT.y > b.COMPONENT.y) {
            return 1;
            // a and b are the same
        } else {
            return 0;
        }
    }
    compare_prop_rowId(a: any, b: any) {

        // a should come before b in the sorted order
        if (a.COMPONENT.rowId < b.COMPONENT.rowId) {
            return -1;
            // a should come after b in the sorted order
        } else if (a.COMPONENT.rowId > b.COMPONENT.rowId) {
            return 1;
            // a and b are the same
        } else {
            return 0;
        }
    }
    easeInSine = function (x: number) {
        return "easeInSine";

    };
    startDrop(onSymbolsCreated: any, onComplete: any) {
        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols,
            count = 0;
        gridSymbols.sort(this.compare_prop_y)
        this.props.setSpinning(true);
        this.newPositions = [];
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "reelDisappear", loop: false }]);
        }
        gridSymbols.forEach((symbol: any, index: number) => {

            let timer = TIMER.TimerManager.createTimer(1 + this.props.data.staggerDropDelayReelStart);
            timer.on('end', (e: any) => {
                e.remove();
                symbol.COMPONENT.updatedTexture = false;
                // let durationTween =

                let dropDuration: any;
                if (this.props.InTurboMode) {
                    dropDuration = 40 * this.regulationBetLimit * (gridSymbols.length - index) / this.toConvertInSec
                } else {
                    dropDuration = this.props.data.singlePositionDropDuration * this.regulationBetLimit * (gridSymbols.length - index) / this.toConvertInSec
                }

                this.tweenTo(symbol.COMPONENT, 'y',
                    this.endPosition.y + symbol.COMPONENT.height * symbol.COMPONENT.gridPosition
                    , dropDuration, "easeInCirc", (e: any) => {



                    }, (e: any) => {

                        // if (symbol.COMPONENT.y >= this.endPosition.y && !symbol.COMPONENT.updatedTexture) {
                        //     symbol.COMPONENT.updatedTexture = true;

                        //     this.props.onUpdateSymbolOnReel(symbol.COMPONENT, this.GRID_STOPS[this.props.GridIndex][symbol.COMPONENT.gridPosition], false);

                        //     symbol.COMPONENT.visible = true;
                        //     symbol.COMPONENT.y = this.endPosition.y;

                        //     if (gridSymbols.length - 1 === index) {
                        //         //

                        //         timer = TIMER.TimerManager.createTimer(500 * this.regulationBetLimit);
                        //         timer.on('end', (e: any) => {

                        //             if (!this.stopButtonClicked) {

                        //                 this.props.setStartDropComplete();
                        //             }
                        //         });
                        //         timer.start();


                        //     }


                        // }
                        count += 1;
                        // symbol.COMPONENT.y = this.createPosition.y * count;
                        if (this.props.GridIndex + 1 === this.props.data.GRID_COLUMN && gridSymbols.length === count) {
                            this.dropComplete = true;

                            this.setDropSymbol();
                        }


                    });

            });
            timer.start();


        });

    }
    startDrop_perfect(onSymbolsCreated: any, onComplete: any) {

        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols,
            count = 0;
        gridSymbols.sort(this.compare_prop_y)
        this.props.setSpinning(true);
        this.newPositions = [];

        gridSymbols.forEach((symbol: any, index: number) => {

            let timer = TIMER.TimerManager.createTimer(1 + this.props.data.staggerDropDelayReelStart);
            timer.on('end', (e: any) => {
                e.remove();
                symbol.COMPONENT.updatedTexture = false;
                // let durationTween =
                this.tweenTo(symbol.COMPONENT, 'y',
                    this.endPosition.y + symbol.COMPONENT.height * symbol.COMPONENT.gridPosition
                    , (this.props.data.singlePositionDropDuration * this.regulationBetLimit * (gridSymbols.length - index)) / this.toConvertInSec, "easeInCirc", (e: any) => {



                    }, (e: any) => {

                        if (symbol.COMPONENT.y >= this.endPosition.y && !symbol.COMPONENT.updatedTexture) {
                            symbol.COMPONENT.updatedTexture = true;

                            this.props.onUpdateSymbolOnReel(symbol.COMPONENT, this.GRID_STOPS[this.props.GridIndex][symbol.COMPONENT.gridPosition], false);

                            symbol.COMPONENT.visible = true;
                            symbol.COMPONENT.y = this.endPosition.y;

                            if (gridSymbols.length - 1 === index) {
                                //

                                timer = TIMER.TimerManager.createTimer(500 * this.regulationBetLimit);
                                timer.on('end', (e: any) => {

                                    if (!this.stopButtonClicked) {

                                        this.props.setStartDropComplete();
                                    }
                                });
                                timer.start();


                            }


                        }
                        count += 1;
                        symbol.COMPONENT.y = this.createPosition.y * count;

                    });

            });
            timer.start();


        });
    }


    easeInCirc = function (x: number) {
        return "easeInCirc";

    };

    startDropAfterBlast(nextProps: any) {

        this.GRID_STOPS = nextProps.reel_data.stopReelsAfterWin;

        let gridSymbols = nextProps.gridList[nextProps.GridIndex].symbols,
            count = 0;
        this.newPositions = [];

        gridSymbols.forEach((symbol: any, index: number) => {
            let timer = TIMER.TimerManager.createTimer(300 + nextProps.data.staggerDropDelay * nextProps.GridIndex);
            timer.on('end', (e: any) => {
                e.remove();
                if (symbol.COMPONENT.blasted || symbol.COMPONENT.giantHide) {
                    nextProps.onUpdateSymbolOnReel(symbol.COMPONENT, this.GRID_STOPS[nextProps.GridIndex][count], false);
                    count += 1;


                    symbol.COMPONENT.y = this.createPosition.y * (count);
                    symbol.COMPONENT.visible = true;
                    const symbolChild = symbol.COMPONENT.children;
                    for (let k = 0; k < symbolChild.length; k++) {
                        symbolChild[k].visible = true
                    }
                    //symbol.COMPONENT.giantHide = false;
                    this.tweenTo(symbol.COMPONENT, 'y',
                        this.gridPositions[this.gridPositions.length - count].y
                        , this.props.data.singlePositionDropDuration * this.regulationBetLimit * (gridSymbols.length - count) / this.toConvertInSec, "easeInCirc", null, () => {
                            this.addTiltTween(symbol, this.leftTilt ? -this.props.data.tiltAngle : this.props.data.tiltAngle, this.props.data.tiltDuration, this.props.data.reversetiltDuration);

                        });

                } else {

                }
            });
            timer.start();

        });

        //  this.onResetGrid(nextProps);

        let timer = TIMER.TimerManager.createTimer(1000 + nextProps.data.staggerDropDelay * this.props.GridIndex);
        timer.on('end', (e: any) => {
            e.remove();
            nextProps.stopWinPresentation();
            this.onResetGrid(nextProps);
            this.reArrangeGridBeforeNextCascade();
            cancelAnimationFrame(this.tickupRequest);

            if (nextProps.GridIndex + 1 === nextProps.data.GRID_COLUMN) {
                // if (this.props.countStopReels === this.props.data.GRID_COLUMN ) {

                if (this.totalCascadeCount - 1 == nextProps.currentCascadeCount + 1) {



                    if (nextProps.featureJustReTriggered) {

                        for (let n = 0; n < nextProps.data.GRID_COLUMN; n++) {
                            const r = nextProps.gridList[n];

                            for (let i = 0; i < r.symbols.length; i++) {

                                if (r.symbols[i].COMPONENT.y < 0) {

                                    r.symbols[i].COMPONENT.visible = false
                                }


                            }
                        }
                    }
                    this.onResetGrid(nextProps);
                    this.props.setSpinComplete(true);

                    /*  this.props.setStopActive(false); */
                    this.props.flowManagerCalled(true);


                } else {


                    this.props.setWinSymbolCoOrdinate([]);
                    let timer = TIMER.TimerManager.createTimer(1000);
                    this.props.setSkullDuringCascade(true);
                    timer.on('end', (e: any) => {
                        this.props.setCurrentCascadeCount(nextProps.currentCascadeCount + 1);
                        this.props.setSpinComplete(true)
                    });
                    timer.start();
                    //this.props.setSpinComplete(true);
                    this.props.displayWinBox(true)




                }
            }

        });
        timer.start();
    }

    createNewSymbols(onSymbolsCreated?: any, onComplete?: any) {

        onSymbolsCreated && onSymbolsCreated();



        this.dropSymbols(onComplete);
    }


    dropSymbols(onComplete: any) {
        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "reelAppear", loop: false }]);
        }
        gridSymbols.sort(this.compare_prop_rowId)
        /*  this.props.setStopActive(false); */
        let timers = TIMER.TimerManager.createTimer(this.stopButtonClicked ? 10 * this.props.GridIndex : this.props.data.delayDropDuration * this.props.GridIndex);
        timers.on('end', (e: any) => {
            e.remove();
            let counter = 0;

            gridSymbols.forEach((symbol: any, index: number) => {
                //let duration = this.props.data.singlePositionDropDurationFromTop * (this.gridPositions.length - index);
                // let duration = this.stopButtonClicked ? 0.3 : (this.props.data.singlePositionDropDuration * (gridSymbols.length - index) * this.regulationBetLimit) / this.toConvertInSec;
                let duration: any;
                if (this.props.InTurboMode) {
                    duration = this.stopButtonClicked ? 0.3 : (40 * (gridSymbols.length - index) * this.regulationBetLimit) / this.toConvertInSec;
                } else {
                    duration = this.stopButtonClicked ? 0.3 : (this.props.data.singlePositionDropDuration * (gridSymbols.length - index) * this.regulationBetLimit) / this.toConvertInSec;
                }

                let timer = TIMER.TimerManager.createTimer(this.stopButtonClicked ? 1 : 1 + this.props.data.staggerDropDelay);

                this.blastSymbol(symbol);
                // this.mergeSymbol(symbol);
                timer.on('end', (e: any) => {
                    e.remove();
                    symbol.COMPONENT.visible = true;
                    this.tweenTo(symbol.COMPONENT, 'y',
                        this.gridPositions[this.gridPositions.length - 1 - index].y
                        , duration, "easeOutCirc", null, () => {
                            counter += 1;
                            this.addTiltTween(symbol, this.leftTilt ? -this.props.data.tiltAngle : this.props.data.tiltAngle, this.props.data.tiltDuration, this.props.data.reversetiltDuration)
                            symbol.COMPONENT.gridPosition = index;
                            symbol.COMPONENT.rowId = symbol.rowId;
                            symbol.COMPONENT.reelId = symbol.reelId;

                            if (counter === gridSymbols.length) {
                                this.reelsComplete();
                            }
                        });

                });
                timer.start();
            });
        });
        timers.start();

    }


    addTiltTween(symbol: any, angle: any, tiltduration: any, reverseDuration: any) {
        let sym_x = symbol.COMPONENT.x
        let sym_y = symbol.COMPONENT.y
        symbol.COMPONENT.pivot.set(symbol.COMPONENT.width / 2, symbol.COMPONENT.height / 2)
        symbol.COMPONENT.position.set(symbol.COMPONENT.width / 2 + sym_x, symbol.COMPONENT.height / 2 + sym_y)
        this.tweenTo(symbol.COMPONENT, 'rotation',
            angle
            , tiltduration / this.toConvertInSec, "easeInCubic", null, () => {
                //symbol.COMPONENT.pivot.set(0.5)
                this.tweenTo(symbol.COMPONENT, 'rotation',
                    0
                    , reverseDuration / this.toConvertInSec, "easeInCubic", null, () => {
                        symbol.COMPONENT.pivot.set(0)
                        symbol.COMPONENT.position.set(0, sym_y)
                    });

            });
    }

    addGlitch(symbol: any) {
        let glitchProperties = {
            "seed": 0,
            "slices": 0,
            "offset": 100,
            "fillMode": 3,
            "average": false,
            "red": [5, 5],
            "green": [5, 5],
            "blue": [5, 5],
            "minSize": 8,
            "sampleSize": 512
        }
        symbol.filters = [new GlitchFilter(glitchProperties)];
        symbol.filters[0].enabled = true;
        let timer = TIMER.TimerManager.createTimer(this.T50);
        timer.on('repeat', (e: any) => {

            symbol.filters[0] && (symbol.filters[0].seed = Math.floor(20 * Math.random()) / 10)
        });
        timer.start(true);

        let timerEnd = TIMER.TimerManager.createTimer(this.T1000);
        timerEnd.on('end', (e: any) => {

            timer.remove();
            symbol.filters[0] && (symbol.filters[0].enabled = false)
        });
        timerEnd.start();
    }

    resetSymbolPivot() {
        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
        gridSymbols.forEach((symbol: any, index: number) => {
            symbol.COMPONENT.children[0].pivot.set(0, 0)
        })
    }



    blastSymbol(symbol: any) {

        this.props.blastPosition.forEach((data: any, index: number) => {

            if (data[0] === symbol.COMPONENT.reelId && data[1] === symbol.COMPONENT.rowId) {

                symbol.COMPONENT.blasted = true;
            }
        })

        // let tempGiantArr = this.props.giantWildPositions
        // tempGiantArr.forEach((position: any, index: number) => {
        //    // console.log("-- YAHOO T4 : gamegrid:blastSymbol:  --", position.reel, position.row, ":", symbol.COMPONENT.reelId, symbol.COMPONENT.rowId, "::", symbol.reelId, symbol.rowId);

        //     if (tempGiantArr.length === 4 && index === 1) {
        //         symbol.COMPONENT.giantHide = false;
        //     } else if (tempGiantArr.length === 9 && index === 2) {
        //         symbol.COMPONENT.giantHide = false;
        //     } else {
        //         if (position.reel === symbol.COMPONENT.reelId && position.row === symbol.COMPONENT.rowId) {
        //             symbol.COMPONENT.giantHide = true;
        //         }
        //     }
        // });

    }
    blastSymbol__() {


        let gridSymbols = this.props.gridList[this.props.GridIndex];

        let symbolslist = gridSymbols.symbols;

        for (let i = 0; i < symbolslist.length; i++) {
            let symbol = symbolslist[i];

            symbol.COMPONENT.gridPosition = i;
            symbol.COMPONENT.rowId = symbol.rowId;
            symbol.COMPONENT.reelId = symbol.reelId;


            this.props.blastPosition.forEach((data: any, index: number) => {

                if (data.reelId === symbol.reelId && data.rowId === symbol.COMPONENT.gridPosition) {


                    symbol.COMPONENT.blasted = true;


                }

            })
        }
    }

    blastSymbol_(symbol: any) {
        this.props.blastPosition.forEach((data: any, index: number) => {
            if (data.reelId === symbol.COMPONENT.reelId && data.rowId === symbol.COMPONENT.rowId) {
                symbol.COMPONENT.blasted = true;
            }
        })
    }

    endBlast(symbol: any) {



    }


    startBlast() {

        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
        let shiftCount = 0;



        for (let j = this.props.data.GRID_ROWS - 1; j >= 0; j--) {
            gridSymbols[j].COMPONENT.shiftCount = shiftCount;

            if (gridSymbols[j].COMPONENT.giantHide) {
                let symbolContainer = gridSymbols[j].COMPONENT;
                symbolContainer.visible = false;
                shiftCount += 1;
            }
            if (gridSymbols[j].COMPONENT.blasted) {

                //this.addGlitch(gridSymbols[j].COMPONENT);
                //this.props.displayWinBox(false)
                let timer = TIMER.TimerManager.createTimer(this.props.data.delayInSymbolAnimationPlay);
                timer.on('end', (e: any) => {
                    e.remove();
                    let symbolContainer = gridSymbols[j].COMPONENT;

                    symbolContainer.visible = false;
                    //this.props.setSymbolAnimationName("", "blast", null, null)
                    this.props.playSymbolAnim();
                    let wincordinate: any = [];

                    this.props.blastPosition.forEach((data: any, index: number) => {
                        wincordinate.push({
                            "reelId": data.reelId,
                            "rowId": data.rowId,
                        })
                    });

                    this.props.setWinSymbolCoOrdinate(wincordinate);
                    let windropTimer = TIMER.TimerManager.createTimer(1500);
                    windropTimer.on('end', (e: any) => {
                        e.remove();
                        this.props.setStartWinDrop(true);

                    });

                    windropTimer.start();

                    let zoomTimer = TIMER.TimerManager.createTimer(5);
                    zoomTimer.on('end', (e: any) => {
                        e.remove();
                        this.addZoomToSymbolAnimation();

                    });
                    zoomTimer.start()


                    //this.props.displayWinBox(false)
                });
                timer.start();
                shiftCount += 1;
            }
            if (shiftCount > 0) {
                gridSymbols[j].shifted = true
            } else {
                gridSymbols[j].shifted = false
            }

        }


        // let resettimertimer = TIMER.TimerManager.createTimer(2000);
        // resettimertimer.on('end', (e: any) => {
        //     e.remove();

        //     if (this.props.GridIndex + 1 === this.props.data.GRID_COLUMN) {
        //         // this.props.clearOverlaySymbol();
        //         this.props.resetDropAfterBlast();
        //     }

        // });

        // resettimertimer.start();
        if (this.props.GridIndex + 1 === this.props.data.GRID_COLUMN) {
            // this.props.clearOverlaySymbol();
            this.props.resetDropAfterBlast();
        }
        // let blasttimertimer = TIMER.TimerManager.createTimer(this.props.data.blastDuration);
        // blasttimertimer.on('end', (e: any) => {
        //     e.remove();
        //     this.reArrangeGrid();

        // });

        // blasttimertimer.start();
        let timer = TIMER.TimerManager.createTimer(2000);

        timer.on('end', (e: any) => {
            e.remove();
            this.responseReceivedAfterBlast = true;
            this.continueFlow(this.props);
        });
        timer.start();


    }

    addZoomToSymbolAnimation() {
        let animContainer = UIManager.getRef("symbolanimationcontainer");
        let startX = configGame.REEL_CONTAINER_X;;
        let startY = configGame.REEL_CONTAINER_Y;

        animContainer.pivot.set(animContainer.width / 2, animContainer.height / 2)
        animContainer.position.set(startX + animContainer.width / 2, startY + animContainer.height / 2)
        new Tween(
            [animContainer.scale],
            {
                'x': { start: 1, end: 1.05 },
                'y': { start: 1, end: 1.05 }
            },
            0.3,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, (e: any) => {
                new Tween(
                    [animContainer.scale],
                    {
                        'x': { start: 1.05, end: 1 },
                        'y': { start: 1.05, end: 1 }
                    },
                    0.3,
                    easing.easeLinear,
                    false, null, null, null, null, false, onchange, (e: any) => {
                        e.dispose();
                    }
                );
                e.dispose();
            }
        );
    }

    continueFlow(nextProps: any) {
        if (this.responseReceivedAfterBlast == true && nextProps.immediateResponseReceived) {
            this.responseReceivedAfterBlast = false;
            this.reArrangeGrid();
            this.startDropAfterBlast(nextProps);
        }
    }

    reArrangeGrid() {

        let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
        for (let j = this.props.data.GRID_ROWS - 1; j >= 0; j--) {
            let shiftCount = gridSymbols[j].COMPONENT.shiftCount;
            if (gridSymbols[j].COMPONENT.blasted || gridSymbols[j].COMPONENT.giantHide) {
                shiftCount = 0;
            }
            if (shiftCount > 0) {
                this.tweenTo(gridSymbols[j].COMPONENT, 'y',
                    gridSymbols[j].COMPONENT.y + this.props.data.SYMBOL_HEIGHT * shiftCount
                    , (this.T50) / this.toConvertInSec, "easeInCirc", null, () => {
                        let shiftCount = gridSymbols[j].COMPONENT.shiftCount;
                        if (shiftCount > 0) {
                            this.addTiltTween(gridSymbols[j], this.leftTilt ? -this.props.data.tiltAngle : this.props.data.tiltAngle, this.props.data.tiltDuration, this.props.data.reversetiltDuration);
                        }
                    });
            }

        }


    }

    reArrangeGrid_() {

        for (let i = 0; i < this.props.data.GRID_COLUMN; i++) {
            let gridSymbols = this.props.gridList[this.props.GridIndex].symbols;
            for (let j = this.props.data.GRID_ROWS - 1; j >= 0; j--) {
                let shiftCount = gridSymbols[j].COMPONENT.shiftCount;
                if (gridSymbols[j].COMPONENT.blasted) {
                    shiftCount = 0;
                }
                let moveY = gridSymbols[j].COMPONENT.y + this.props.data.SYMBOL_HEIGHT * shiftCount;
                if (moveY >= this.gridPositions[0].y) {
                    moveY = this.gridPositions[0].y
                } else if (moveY >= this.gridPositions[1].y && moveY < this.gridPositions[0].y) {
                    moveY = this.gridPositions[1].y
                } else {
                    moveY = this.gridPositions[2].y
                }

                if (shiftCount > 0) {
                    //this.addTiltTween(gridSymbols[j], this.leftTilt ? -this.props.data.tiltAngle : this.props.data.tiltAngle, this.props.data.tiltDuration, this.props.data.reversetiltDuration);

                }

                this.tweenTo(gridSymbols[j].COMPONENT, 'y',
                    moveY
                    , (this.T50 * (this.gridPositions.length - j)) / this.toConvertInSec, "easeOutExpo", null, () => {

                        if (gridSymbols[j].COMPONENT.blasted) {



                        }
                    });
            }
        }

    }

    reelsComplete() {

        this.props.setSpinning(false);
        this.reelRunning = false;
        this.serverResponseReceived = false;
        this.props.setStartWinDrop(false);
        this.props.setStoppedReel(this.props.GridIndex);

    }


    private tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {
        let tweenObj = new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time || 0.001,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );
        this.tweening.push(tweenObj);
    }



    render() {
        if (this.GRID_STOPS.length === 0) {
            console.error("grid are empty")
            return <></>;
        }
        const reel = {
            container: this.getSubReelContainer(),
            Id: this.props.GridIndex,
            symbols: [],
            position: 0,
            previousPosition: 0,
            blur: new PIXI.filters.BlurFilter(),
        };
        reel.blur.blurX = 4;
        reel.blur.blurY = 4;


        this.props.gridList.push(reel);

        const symbols_array = [];
        for (let j = 0; j < this.props.data.GRID_ROWS; j++) {
            let symbolId = this.GRID_STOPS[this.props.GridIndex][j];
            let PROPS_TO_SEND_Symbol = {
                key: "symbol_" + this.props.GridIndex + "_" + j,
                SYMBOL_ID: symbolId,
                ROW_ID: j,
                REEL_ID: this.props.GridIndex,
                REEL: reel
            }
            symbols_array.push(
                <Symbol {...PROPS_TO_SEND_Symbol}>

                </Symbol>
            );

        }


        return (<UIManager type={"Container"} ref={(i: any) => this.subGameGridContainer = i} app={this.app}
            id={"gridGameCoulmn" + this.props.GridIndex} name={"gridGameCoulmn" + this.props.GridIndex}
            x={this.props.GridIndex * this.props.data.GRID_WIDTH + this.props.GridIndex * this.props.data.GRID_GAP}>
            {symbols_array}
        </UIManager>)
    }

    ticker() {

    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'gridsState' | 'soundState' | 'randomWildsState' | 'buttonPanelState' | 'giantWildState' | 'symbolState' | 'applicationState' | 'baseGameReconstructionState'>): IStateToProps =>
    ({
        //updatedSymbol: state.symbolState.updatedSymbol,
        blastPosition: state.gridsState.blastPosition,
        isSpinning: state.gridsState.isSpinning,
        spinStart: state.gridsState.spinStart,
        blastStart: state.gridsState.blastStart,
        spinStop: state.gridsState.spinStop,
        forceSpinStop: state.gridsState.forcespinStop,
        spinResponseReceived: state.gridsState.spinResponseReceived,
        allSpinComplete: state.gridsState.allSpinComplete,
        winningList: state.gridsState.winningList,
        reel_data: state.gridsState.reel_data,
        layoutMode: state.applicationState.layoutMode,
        startDropCompleteCount: state.gridsState.startDropCompleteCount,
        currentCascadeCount: state.gridsState.currentCascadeCount,
        totalCascadeCount: state.gridsState.totalCascadeCount,
        countStopReels: state.gridsState.countStopReels,
        giantWildPositions: state.giantWildState.giantWildPositions,
        immediateResponseReceived: state.gridsState.immediateResponseReceived,
        randomWildsPositions: state.randomWildsState.randomWildsPositions,
        InTurboMode: state.gridsState.InTurboMode,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        soundIsPlaying: state.soundState.soundIsPlaying,
        showBannerForReconstruction: state.baseGameReconstructionState.showBannerForReconstruction,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({

        playSymbolAnim: (): any => dispatch(winpresentationAction.playSymbolAnim()),
        displayWinBox: (displayWinBox: boolean): any => dispatch(winpresentationAction.displayWinBox(displayWinBox)),

        setWinSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(winpresentationAction.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        setSpinType: (): any => dispatch(gridActions.setSpinType()),
        setSpinning: (spinning: boolean): any => dispatch(gridActions.setSpinningState(spinning)),
        setSpinComplete: (allSpinComplete: boolean): any => dispatch(gridActions.setSpinComplete(allSpinComplete)),
        setStoppedReel: (stoppedReel: number): any => dispatch(gridActions.setStoppedReel(stoppedReel)),
        onUpdateSymbolOnReel: (symbol: any, symbolId: number, randomSymbol: boolean): any => dispatch(symbolActions.setUpdatedSymbol(symbol, symbolId, randomSymbol)),
        onDropSymbolOnReel: (symbol: any, symbolId: any): any => dispatch(symbolActions.setDropSymbol(symbol, symbolId)),
        setSymbolAnimationName: (symbol: any, animationname: string, callback: any, callbackScope: any): any => dispatch(symbolActions.setSymbolAnimationName(symbol, animationname, callback, callbackScope)),
        setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setStartDropComplete: (): any => dispatch(gridActions.setStartDropComplete()),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        setCurrentCascadeCount: (currentCascadeCountAction: number): any => dispatch(gridActions.setCurrentCascadeCount(currentCascadeCountAction)),
        startGiantWild: (): any => dispatch(gaintWildActions.startGiantWild()),
        startRandomWild: (): any => dispatch(randomWildActions.startRandomWild()),
        // clearOverlaySymbol: (): any => dispatch(overlayActions.clearOverlaySymbol()),
        resetDropAfterBlast: (): any => dispatch(gridActions.resetDropAfterBlast()),
        setStartWinDrop: (startDrop: number): any => dispatch(winDropReducer.setStartWinDrop(startDrop)),
        /*  setStopActive: (stopActive: boolean): any => dispatch(buttonActions.setStopActive(stopActive)), */
        setSkullDuringCascade: (skullCascade: boolean): any => dispatch(skullActions.setSkullDuringCascade(skullCascade)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        featureActive: (isFeatureActive: boolean): any => dispatch(gameRandomWildActions.featureActive(isFeatureActive)),
    }))(withGameGridConfiguration(GameGrid)));
